import { computed, ref, watch } from 'vue'

type ModalState = boolean

export function useModalState(options: { initialState?: ModalState } = { }) {
  const { initialState = false } = options

  const state = ref(initialState)

  return {
    isOpen: computed(() => state.value),
    open() {
      state.value = true
    },

    isClosed: computed(() => !state.value),
    close() {
      state.value = false
    },

    state: computed({
      get() {
        return state.value
      },
      set(value: ModalState) {
        state.value = value
      }
    }),
  }
}
